import { render, staticRenderFns } from "./SobrenosotrosView.vue?vue&type=template&id=1482cc88&scoped=true"
import script from "./SobrenosotrosView.vue?vue&type=script&lang=js"
export * from "./SobrenosotrosView.vue?vue&type=script&lang=js"
import style0 from "./SobrenosotrosView.vue?vue&type=style&index=0&id=1482cc88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482cc88",
  null
  
)

export default component.exports